"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LruCache = void 0;
var LruCache = (function () {
    function LruCache() {
        this.values = new Map();
        this.maxEntries = 20;
    }
    LruCache.prototype.get = function (key) {
        var hasKey = this.values.has(key);
        if (hasKey) {
            var entry = this.values.get(key);
            this.values.delete(key);
            this.values.set(key, entry);
            return entry;
        }
        return null;
    };
    LruCache.prototype.put = function (key, value) {
        if (this.values.size >= this.maxEntries) {
            var keyToDelete = this.values.keys().next().value;
            this.values.delete(keyToDelete);
        }
        this.values.set(key, value);
    };
    return LruCache;
}());
exports.LruCache = LruCache;
//# sourceMappingURL=lrucache.js.map